import tw from 'twin.macro';

export const Main = tw.main`w-full block bg-grey-dark z-10 min-h-screen`;
